import { CalendarStep } from '../steps/CalendarStep'
import { AboutCakeStep } from '../steps/AboutCakeStep'
import { FillingStep } from '../steps/FillingStep'
import { DetailsStep } from '../steps/DetailsStep'
import { CheckoutStep } from '../steps/CheckoutStep'

export const STEPS = [
  CalendarStep,
  AboutCakeStep,
  FillingStep,
  DetailsStep,
  CheckoutStep,
]
